<template>
  <div class="account-delegate-page">

        <!-- 股票投资板块 -->
        <section class="stock-investment py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid  lg:grid-cols-2 gap-12 items-center">
          <!-- 左侧文字说明区 -->
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">
              {{ getContent('stock_investment_title', '股票投资') }}
            </h3>
            <p class="text-gray-600 text-lg leading-relaxed">
              {{ getContent('stock_investment_description', '红土证券覆盖多种交易产品，满足您多样的投资组合策略') }}
            </p>
          </div>

          <!-- 右侧图标展示区 -->
          <div class="icon-showcase flex justify-center">
                <img :src="getImageUrl('image_stock_investment', '/assets/bx1.png')">
          </div>
        </div>
      </div>
    </section>

    <!-- Longbridge优势板块 -->
    <section class="longbridge-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 标题 -->
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">
            {{ advantages_title }}
          </h2>
        </div>

        <!-- 优势卡片网格 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">

          <!-- 第一行左侧：免佣优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <!-- 橙色盾牌图标 -->
              <img :src="getImageUrl('advantage1_icon', '/assets/kh1.png')" alt="advantage1">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage1_text }}
              </p>
            </div>
          </div>

          <!-- 第一行右侧：技术工具优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <!-- 橙色圆形定位针图标 -->
              <img :src="getImageUrl('advantage2_icon', '/assets/kh4.png')" alt="advantage2">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage2_text }}
              </p>
            </div>
          </div>

          <!-- 第二行左侧：市场覆盖优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
            <img :src="getImageUrl('advantage3_icon', '/assets/kh2.png')" class="w-13 h-13" alt="advantage3">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage3_text }}
              </p>
            </div>
          </div>

          <!-- 第二行右侧：出入金方式优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img :src="getImageUrl('advantage4_icon', '/assets/kh5.png')" alt="advantage4">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage4_text }}
              </p>
            </div>
          </div>

          <!-- 第三行左侧：个性化服务优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
             <img :src="getImageUrl('advantage5_icon', '/assets/kh3.png')" alt="advantage5">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage5_text }}
              </p>
            </div>
          </div>

          <!-- 第三行右侧：安全保障优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
             <img :src="getImageUrl('advantage6_icon', '/assets/kh6.png')" alt="advantage6">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage6_text }}
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- 专享特权板块 -->
    <section class="exclusive-privileges py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <!-- 左侧卡片展示区 -->
          <div class="privilege-cards">
              <img :src="getImageUrl('privilege_image', '/assets/image3.png')" alt="privilege">
          </div>

          <!-- 右侧文字说明区 -->
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">
              {{ privilege_title }}
            </h3>

            <ul class="space-y-4 mb-6">
              <li class="flex items-start" v-for="(item, index) in privilege_items" :key="index">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">
                  {{ item }}
                </span>
              </li>
            </ul>

            <!-- 存仓费0强调 -->
            <div class="highlight-box  p-4 pl-0 mb-6">
              <p class="text-[#ef7c5b] font-semibold text-lg">
                {{ privilege_highlight }}
              </p>
            </div>

            <!-- 了解详情按钮 -->
            <button class="bg-[#ef7c5b] cursor-pointer text-white px-8 py-2 rounded-3xl font-semibold transition-colors">
              {{ privilege_button_text }}
            </button>
          </div>

        </div>
      </div>
    </section>

    <!-- 投资者工具板块 -->
    <section class="investor-tools py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <!-- 左侧文字说明区 -->
          <div class="text-content">
            <h3 class="text-3xl font-bold text-gray-900 mb-6">
              {{ tools_title }}
            </h3>

            <ul class="space-y-6" v-if="tools_items">
              <li class="flex items-start" v-for="(tool, index) in tools_items" :key="index">
                <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
                <div>
                  <p class="text-gray-900 font-semibold mb-1">{{ tool.title }}</p>
                  <p class="text-gray-700 leading-relaxed">
                    {{ tool.description }}
                  </p>
                </div>
              </li>
            </ul>

            <!-- 了解详情按钮 -->
            <button class="bg-[#ef7c5b] cursor-pointer text-white px-8 py-2 mt-4 rounded-3xl font-semibold transition-colors">
              {{ tools_button_text }}
            </button>
          </div>

          <!-- 右侧展示区 -->
          <div class="phone-showcase flex justify-center">
            <img :src="getImageUrl('tools_image', '/assets/image3.png')" alt="tools">
          </div>

        </div>
      </div>
    </section>

    <!-- 全球交易板块 -->
    <section class="global-trading py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">

        <!-- 上方标题 -->
        <div class="text-center mb-12">
          <h2 class="text-4xl font-bold text-gray-900 mb-8">
            {{ getContent('global_trading_title', '全球交易') }}
          </h2>

          <!-- 特色亮点展示区 -->
          <div class="features-grid grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-8">
            <!-- 第一个图标：文件/账户形状 -->
            <div class="feature-item text-center">
              <div class="feature-icon mx-auto mb-4">
                <img :src="getImageUrl('image_global_trading_feature1', '/assets/wt1.png')">
              </div>
              <p class="text-gray-600 text-sm leading-relaxed">
                {{ getContent('global_trading_feature1_text', '一个账户，多个币种，投资全球') }}
              </p>
            </div>

            <!-- 第二个图标：现金形状 -->
            <div class="feature-item text-center">
              <div class="feature-icon mx-auto mb-4">
                <img :src="getImageUrl('image_global_trading_feature2', '/assets/wt2.png')">
              </div>
              <p class="text-gray-600 text-sm leading-relaxed">
                {{ getContent('global_trading_feature2_text', '多达 32,000 只可交易标的') }}
              </p>
            </div>

            <!-- 第三个图标：上升折线图 -->
            <div class="feature-item text-center">
              <div class="feature-icon mx-auto mb-4">
                <img :src="getImageUrl('image_global_trading_feature3', '/assets/wt3.png')">
              </div>
              <p class="text-gray-600 text-sm leading-relaxed">
                {{ getContent('global_trading_feature3_text', '多样化、便捷的入金方式，实时到账开始交易') }}
              </p>
            </div>

            <!-- 第四个图标：循环图案 -->
            <div class="feature-item text-center">
              <div class="feature-icon mx-auto mb-4">
                <img :src="getImageUrl('image_global_trading_feature4', '/assets/wt4.png')">
              </div>
              <p class="text-gray-600 text-sm leading-relaxed">
                {{ getContent('global_trading_feature4_text', '多样的优惠活动，更低的交易成本') }}
              </p>
            </div>

            <!-- 第五个图标：齿轮/流程图 -->
            <div class="feature-item text-center">
              <div class="feature-icon mx-auto mb-4">
                <img :src="getImageUrl('image_global_trading_feature5', '/assets/wt5.png')">
              </div>
              <p class="text-gray-600 text-sm leading-relaxed">
                {{ getContent('global_trading_feature5_text', '极致流畅的交易体验，享受每个下单瞬间') }}
              </p>
            </div>
          </div>
        </div>

        <!-- 过渡说明文字 -->
        <div class="text-center mb-8">
          <p class="text-gray-500 text-sm">
            {{ getContent('global_trading_coverage_description', '红土证券覆盖多种交易产品，满足您多样的投资组合策略') }}
          </p>
        </div>

        <!-- 产品与地区展示区 - 表格 -->
        <div class="overflow-x-auto mb-8">
          <table class="w-full text-left border-collapse border border-gray-200">
            <thead>
              <tr class="bg-gray-100">
                <th class="px-6 py-4 text-sm font-semibold text-gray-700 border border-gray-200">
                  国家/地区
                </th>
                <th class="px-6 py-4 text-sm font-semibold text-gray-700 border border-gray-200 text-center">
                  股票
                </th>
                <th class="px-6 py-4 text-sm font-semibold text-gray-700 border border-gray-200 text-center">
                  ETFS
                </th>
                <th class="px-6 py-4 text-sm font-semibold text-gray-700 border border-gray-200 text-center">
                  债券
                </th>
                <th class="px-6 py-4 text-sm font-semibold text-gray-700 border border-gray-200 text-center">
                  权证
                </th>
                <th class="px-6 py-4 text-sm font-semibold text-gray-700 border border-gray-200 text-center">
                  期权
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border border-gray-200" v-for="(country, index) in globalTradingTableData" :key="index">
                <td class="px-6 py-4 border border-gray-200">
                  <div class="flex items-center">
                    <span class="text-lg mr-3">{{ country.flag }}</span>
                    <span class="font-medium">{{ country.country }}</span>
                  </div>
                </td>
                <td class="px-6 py-4 text-center border border-gray-200">
                  <div v-if="country.stocks" class="w-3 h-3 bg-orange-500 rounded-full mx-auto"></div>
                </td>
                <td class="px-6 py-4 text-center border border-gray-200">
                  <div v-if="country.etfs" class="w-3 h-3 bg-orange-500 rounded-full mx-auto"></div>
                </td>
                <td class="px-6 py-4 text-center border border-gray-200">
                  <div v-if="country.bonds" class="w-3 h-3 bg-orange-500 rounded-full mx-auto"></div>
                </td>
                <td class="px-6 py-4 text-center border border-gray-200">
                  <div v-if="country.warrants" class="w-3 h-3 bg-orange-500 rounded-full mx-auto"></div>
                </td>
                <td class="px-6 py-4 text-center border border-gray-200">
                  <div v-if="country.options" class="w-3 h-3 bg-orange-500 rounded-full mx-auto"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 底部链接区 -->
        <div class="flex justify-center gap-8">
          <a href="#" class="market-link flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors">
            <span class="text-lg mr-2">🇭🇰</span>
            {{ getContent('global_trading_hk_market', '港股市场') }}
          </a>
          <a href="#" class="market-link flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors">
            <span class="text-lg mr-2">🇺🇸</span>
            {{ getContent('global_trading_us_market', '美股市场') }}
          </a>
        </div>
      </div>
    </section>

    <!-- 订单类型板块 -->
    <section class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <h1 class="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">{{ getContent('order_types_title', '订单类型') }}</h1>

        <!-- 订单类型标签（独占一行，左对齐） -->
        <div class="mb-6">
          <div class="flex justify-start gap-8 border-b border-gray-200 pb-3">
            <button
              v-for="tab in orderTypesTabs"
              :key="tab.key"
              @click="setOrderTab(tab.key)"
              :class="['nav-tab', { active: orderTypes_orderTab === tab.key }]"
            >
              {{ tab.name }}
            </button>
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          <!-- 左侧图标区 -->
          <div class="flex items-center justify-center">
            <img :src="getImageUrl('image_order_types', '/assets/bjdd.png')" :alt="getContent('order_types_image_alt', '订单类型图标')">
          </div>

          <!-- 右侧文字说明区 -->
          <div class="lg:col-span-2">
            <!-- 动态显示选中的订单类型内容 -->
            <div v-if="orderTypes_content[orderTypes_orderTab]" class="order-type-content">
              <h3 class="text-2xl font-bold text-gray-900 mb-3">{{ orderTypes_content[orderTypes_orderTab].title }}</h3>
              <p class="text-gray-800 mb-4" v-html="orderTypes_content[orderTypes_orderTab].desc1"></p>
              <p class="text-gray-800 mb-4" v-html="orderTypes_content[orderTypes_orderTab].desc2"></p>

              <h4 v-if="orderTypes_content[orderTypes_orderTab].trading_hours_title" class="font-semibold text-gray-900 mb-2">
                {{ orderTypes_content[orderTypes_orderTab].trading_hours_title }}
              </h4>
              <ul v-if="orderTypes_content[orderTypes_orderTab].trading_hours" class="text-gray-800 list-none space-y-2">
                <li v-for="hour in orderTypes_content[orderTypes_orderTab].trading_hours" :key="hour">{{ hour }}</li>
              </ul>
            </div>

            <!-- 当内容不存在时显示默认消息 -->
            <div v-else class="text-gray-700">
              <p>{{ orderTypes_defaultMessagePrefix }}<span class="font-semibold text-gray-900">{{ getOrderTypeDisplayName(orderTypes_orderTab) }}</span>{{ orderTypes_defaultMessageSuffix }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 保证金交易板块 -->
   

    <!-- 到价买入板块 -->
    <section class="if-touched-section py-12 bg-gradient-to-r from-orange-500 to-orange-400 text-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 顶部水平导航（左对齐） -->
        <div class="mb-6">
          <div class="flex justify-start gap-8">
            <button
              v-for="tab in buyIfTouchedTriggerTabs"
              :key="tab.key"
              @click="setActiveTrigger(tab.key)"
              :class="['top-nav-tab', { active: buyIfTouched_activeTrigger === tab.key }]"
            >
              {{ tab.name }}
            </button>
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <!-- 左侧文字说明区 -->
          <div>
            <h2 class="text-2xl font-bold mb-4">{{ getContent('buy_if_touched_title', '到价买入') }}</h2>
            <p class="text-white mb-4" v-html="buyIfTouched_currentTriggerContent.definition"></p>
            <p class="text-white mb-4" v-html="buyIfTouched_currentTriggerContent.scenarios"></p>

            <h3 class="font-semibold text-white mb-2">{{ buyIfTouched_currentTriggerContent.tradingHoursTitle }}</h3>
            <ul class="text-white list-none space-y-2">
              <li v-for="hour in buyIfTouched_currentTriggerContent.tradingHours" :key="hour">{{ hour }}</li>
            </ul>
            <p class="text-white mt-4" v-html="buyIfTouched_currentTriggerContent.monitoringNote"></p>
          </div>

          <!-- 右侧图标区 -->
          <div class="flex items-center justify-center">
            <img :src="getImageUrl('image_buy_if_touched', '/assets/bjdd.png')" :alt="getContent('buy_if_touched_image_alt', '到价买入图标')">
          </div>
        </div>
      </div>
    </section>
    <section class="margin-trading py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 标题与概念说明 -->
        <div class="text-center mb-12">
          <h2 class="text-4xl font-bold text-gray-900 mb-6">
            {{ getContent('margin_trading_title', '保证金交易') }}
          </h2>
          <p class="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            {{ getContent('margin_trading_description', '通过向长桥融入资金以获取更大购买力来获取更高利润，同时也将承担更高风险') }}
          </p>
        </div>

        <!-- 概念及示例展示区 -->
        <div class="concept-examples grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <!-- 左侧柱状图 - 最大购买力 -->
          <div class="example-card bg-white border border-gray-200 rounded-lg p-8 text-center">
                <img :src="getImageUrl('image_margin_trading_chart1', '/assets/b1.png')">
          </div>

          <!-- 右侧柱状图 - 盈亏 -->
          <div class="example-card bg-white border border-gray-200 rounded-lg p-8 text-center">
                <img :src="getImageUrl('image_margin_trading_chart2', '/assets/b2.png')">
          </div>
        </div>

        <!-- 分割线 -->
        <div class="divider border-t border-gray-200 mb-16"></div>

        <!-- 优势和风险列举区 -->
        <div class="advantages-section mb-16">
          <h3 class="text-2xl font-bold text-gray-900 text-center mb-8">{{ getContent('margin_trading_advantages_title', '优势') }}</h3>

          <div class="advantages-grid grid grid-cols-1 md:grid-cols-3 gap-8">
            <!-- 第一个优势 -->
            <div class="advantage-item bg-white border border-gray-200 rounded-lg p-6 flex items-start">
              <div class="advantage-icon mr-4">
                <img :src="getImageUrl('image_margin_trading_advantage1', '/assets/ys1.png')">
              </div>
              <div class="flex-1">
                <p class="text-gray-900 font-medium">{{ getContent('margin_trading_advantage1_text', '以超过持有现金的额度买入股票') }}</p>
              </div>
            </div>

            <!-- 第二个优势 -->
            <div class="advantage-item bg-white border border-gray-200 rounded-lg p-6 flex items-start">
              <div class="advantage-icon mr-4">
                <img :src="getImageUrl('image_margin_trading_advantage2', '/assets/ys2.png')">

              </div>
              <div class="flex-1">
                <p class="text-gray-900 font-medium">{{ getContent('margin_trading_advantage2_text', '有竞争力的融资比例') }}</p>
              </div>
            </div>

            <!-- 第三个优势 -->
            <div class="advantage-item bg-white border border-gray-200 rounded-lg p-6 flex items-start">
              <div class="advantage-icon mr-4">
                <img :src="getImageUrl('image_margin_trading_advantage3', '/assets/ys3.png')">

              </div>
              <div class="flex-1">
                <p class="text-gray-900 font-medium">{{ getContent('margin_trading_advantage3_text', '抵押持有的股票来获取额外的购买力') }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 分割线 -->
        <div class="divider border-t border-gray-200 mb-16"></div>

        <!-- 风险提示区 -->
        <div class="risk-warning bg-gray-50 border border-gray-200 rounded-lg p-8">
          <h3 class="text-2xl font-bold text-gray-900 mb-6 text-center">
            {{ getContent('margin_trading_risks_title', '关于融资交易你需要知道的风险') }}
          </h3>

          <ul class="space-y-4 max-w-4xl mx-auto">
            <li class="flex items-start">
              <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
              <span class="text-gray-700 leading-relaxed">{{ getContent('margin_trading_risk1_text', '相比于现金交易可能存在更高的亏损风险') }}</span>
            </li>
            <li class="flex items-start">
              <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
              <span class="text-gray-700 leading-relaxed">{{ getContent('margin_trading_risk2_text', '需要额外付出融资利息费用') }}</span>
            </li>
            <li class="flex items-start">
              <span class="w-3 h-3 bg-orange-500 rounded-full mt-2 mr-4 flex-shrink-0"></span>
              <span class="text-gray-700 leading-relaxed">{{ getContent('margin_trading_risk3_text', '当市场剧烈波动时可能面临追缴或被强制平仓的风险') }}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 交易能力板块 -->
    <section class="trading-capabilities py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 标题 -->
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">
            {{ trading_title }}
          </h2>
        </div>

        <!-- 能力卡片网格 -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          <div class="capability-card bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow" v-for="(capability, index) in trading_capabilities" :key="index">
            <div class="icon-container ">
             <img :src="getImageUrl(capability.icon, capability.icon)" class="w-13 h-13" :alt="capability.title">
            </div>
            <h3 class="text-xl font-semibold text-gray-900 mb-3">
              {{ capability.title }}
            </h3>
            <ul class="text-gray-700 space-y-1 text-sm" v-if="capability.features">
              <li v-for="(feature, fIndex) in capability.features" :key="fIndex">• {{ feature }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 值得信赖的证券经纪服务商 -->
    <section class="trusted-broker py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">{{ trusted_title }}</h2>
          <p class="text-base text-gray-800 max-w-3xl mx-auto mt-3">
            {{ trusted_subtitle }}
          </p>
        </div>

        <!-- 三列服务优势卡片 -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">

          <div class="service-card bg-white rounded-lg p-6 shadow-sm" v-for="(service, index) in trusted_services" :key="index">
            <div class="icon-top flex items-center justify-center mb-4">
                <img :src="getImageUrl(service.icon, service.icon)" :alt="service.title">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">{{ service.title }}</h4>
            <ul class="text-gray-700 list-none space-y-3" v-if="service.items">
              <li class="flex items-start" v-for="(item, iIndex) in service.items" :key="iIndex"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>{{ item }}</span></li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <!-- 荣誉奖项展示 -->
    <section class="awards-section bg-white py-16 lg:py-24">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 text-center mb-10">{{ awards_title }}</h2>

        <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" v-if="awards">
          <div class="award-item text-center" v-for="(award, index) in awards" :key="index">
            <div class="award-card mx-auto">
              <img :src="getImageUrl(award.image, '/assets/award1.png')" :alt="award.lines[0]" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div v-for="(line, lIndex) in award.lines" :key="lIndex">{{ line }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 支持账户类型 -->
    <section class="account-types py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">{{ accounts_title }}</h2>
        <p class="text-base text-gray-800 mb-8">{{ accounts_subtitle }}</p>

        <!-- 图标行 -->
        <div class="flex items-center justify-center gap-12 mb-6">
          <div class="flex flex-col items-center" v-for="(account, index) in account_types" :key="index">
            <img :src="getImageUrl(account.icon, account.icon)" :alt="account.name">
            <div class="text-gray-900">{{ account.name }}</div>
          </div>
        </div>

        <!-- 详细说明框 -->
        <div class="max-w-3xl mx-auto border border-gray-200 rounded-lg p-6 bg-white text-left">
          <h4 class="font-semibold text-gray-900 mb-2">{{ account_description.title }}</h4>
          <p class="text-gray-700 text-sm leading-relaxed">
            {{ account_description.content }}
          </p>
        </div>
      </div>
    </section>

    <!-- 做空交易板块 -->
    <section class="short-selling py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 标题与简介 -->
        <div class="text-center mb-12">
          <h2 class="text-4xl font-bold text-gray-900 mb-6">
            {{ getContent('short_selling_title', '做空交易') }}
          </h2>
          <p class="text-gray-600 text-lg max-w-4xl mx-auto leading-relaxed">
            {{ getContent('short_selling_description', '若看空股票走势，可通过向券商借入股票直接卖出，在股票下跌后买入还给券商，以在下跌市场行情下获取股票收益') }}
          </p>
        </div>

        <!-- 做空交易流程图 -->
        <div class="process-flow mb-16 flex justify-center">
            <img :src="getImageUrl('image_short_selling_flow', '/assets/lct.png')">
        </div>

        <!-- 分割线 -->
        <div class="divider border-t border-gray-200 mb-16"></div>

        <!-- 做空优势说明 -->
        <div class="short-advantages">
          <h3 class="text-2xl font-bold text-gray-900 text-center mb-8">{{ getContent('short_selling_advantages_title', '做空优势') }}</h3>

          <div class="advantages-grid grid grid-cols-1 md:grid-cols-3 gap-8">
            <!-- 第一个优势 -->
            <div class="advantage-item bg-white border border-gray-200 rounded-lg p-6 flex items-start">
              <div class="advantage-icon mr-4">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="20" stroke="#ff9900" stroke-width="2" fill="none"/>
                  <path d="M16 20 L20 16 L28 24 L36 16 L40 20" stroke="#ff9900" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="16" cy="20" r="2" fill="#ff9900"/>
                  <circle cx="20" cy="16" r="2" fill="#ff9900"/>
                  <circle cx="28" cy="24" r="2" fill="#ff9900"/>
                  <circle cx="36" cy="16" r="2" fill="#ff9900"/>
                  <circle cx="40" cy="20" r="2" fill="#ff9900"/>
                  <text x="24" y="32" text-anchor="middle" fill="#ff9900" font-size="12" font-weight="bold">$</text>
                </svg>
              </div>
              <div class="flex-1">
                <p class="text-gray-900 font-medium">在市场情绪低落的时候能有更多的交易机会获取利润</p>
              </div>
            </div>

            <!-- 第二个优势 -->
            <div class="advantage-item bg-white border border-gray-200 rounded-lg p-6 flex items-start">
              <div class="advantage-icon mr-4">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 16 L16 24 L24 20 L32 28 L40 20" stroke="#ff9900" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="8" cy="16" r="2" fill="#ff9900"/>
                  <circle cx="16" cy="24" r="2" fill="#ff9900"/>
                  <circle cx="24" cy="20" r="2" fill="#ff9900"/>
                  <circle cx="32" cy="28" r="2" fill="#ff9900"/>
                  <circle cx="40" cy="20" r="2" fill="#ff9900"/>
                  <path d="M32 12 L36 16 L32 20" stroke="#ff9900" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                  <text x="24" y="38" text-anchor="middle" fill="#ff9900" font-size="12" font-weight="bold">↓</text>
                </svg>
              </div>
              <div class="flex-1">
                <p class="text-gray-900 font-medium">股票下跌过程中也可做空获取收益</p>
              </div>
            </div>

            <!-- 第三个优势 -->
            <div class="advantage-item bg-white border border-gray-200 rounded-lg p-6 flex items-start">
              <div class="advantage-icon mr-4">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16" cy="16" r="8" stroke="#ff9900" stroke-width="2" fill="none"/>
                  <circle cx="32" cy="32" r="8" stroke="#ff9900" stroke-width="2" fill="none"/>
                  <path d="M16 16 L32 32" stroke="#ff9900" stroke-width="2" fill="none" stroke-linecap="round"/>
                  <path d="M20 12 L24 16 L20 20" stroke="#ff9900" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M28 28 L32 32 L28 36" stroke="#ff9900" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                  <text x="16" y="20" text-anchor="middle" fill="#ff9900" font-size="8" font-weight="bold">L</text>
                  <text x="32" y="36" text-anchor="middle" fill="#ff9900" font-size="8" font-weight="bold">S</text>
                </svg>
              </div>
              <div class="flex-1">
                <p class="text-gray-900 font-medium">通过持有空头仓位进行对冲交易</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="hidden lg:block bg-hongtu-accent">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-16">
        <div class="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8">
          <div class="text-center lg:text-left flex-1">
            <h2 class="text-2xl lg:text-4xl xl:text-5xl font-medium text-white mb-3 lg:mb-4 leading-tight">
              {{ getContent('bottom_section_title', '了解证劵市场，理财收益再升级') }}
            </h2>
            <p class="text-lg lg:text-2xl xl:text-3xl font-medium text-white mb-4 lg:mb-6">
             {{ getContent('bottom_section_subtitle', '多维度分析市场表现') }}
            </p>
            <button style="cursor: pointer;" class="btn-touch bg-hongtu-secondary text-white px-8 py-3 lg:px-6 lg:py-3 rounded-full font-medium hover:bg-hongtu-primary transition-colors duration-200 text-base lg:text-lg">
              {{ getContent('bottom_section_button_text', '立即注册') }}
            </button>
          </div>
          <div class="flex-shrink-0 mt-4 lg:mt-0">
            <img :src="getImageUrl('image_bottom_section', '../assets/23@1x.png')"  class="w-20 h-20 lg:w-auto lg:h-50 xl:w-auto xl:h-80" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getContentsByCategory, ContentMixin } from '../services/contentService';

export default {
  name: 'AccountDelegatePage',
  mixins: [ContentMixin],
  data() {
    return {
      currentLang: 'cn', // 当前语言

      // 订单类型相关数据
      orderTypes_orderTab: 'atAuctionLimit',
      orderTypes_defaultMessagePrefix: '当前选中的订单类型：',
      orderTypes_defaultMessageSuffix: '。该类型的详细说明正在准备中。',

      // 到价买入相关数据
      buyIfTouched_activeTrigger: 'buyIfTouched'
    }
  },
  computed: {
    // 优势板块
    advantages_title() {
      return this.getContent('account_delegate_advantages_title', '账户委托优势');
    },
    advantage1_icon() {
      return this.getImageUrl('advantage1_icon', '/assets/kh1.png');
    },
    advantage1_text() {
      return this.getContent('account_delegate_advantage1_text', '专业的账户管理服务，帮您实现资产的保值增值，专注财富稳健增长。');
    },
    advantage2_icon() {
      return this.getImageUrl('advantage2_icon', '/assets/kh4.png');
    },
    advantage2_text() {
      return this.getContent('account_delegate_advantage2_text', '智能资产配置工具，根据市场情况和您的风险偏好，动态调整投资组合。');
    },
    advantage3_icon() {
      return this.getImageUrl('advantage3_icon', '/assets/kh2.png');
    },
    advantage3_text() {
      return this.getContent('account_delegate_advantage3_text', '丰富的投资标的覆盖，包括股票、基金、债券等多种资产类别，满足全方位投资需求。');
    },
    advantage4_icon() {
      return this.getImageUrl('advantage4_icon', '/assets/kh5.png');
    },
    advantage4_text() {
      return this.getContent('account_delegate_advantage4_text', '便捷的委托服务流程，专业的投资顾问全程陪伴，定期汇报投资情况。');
    },
    advantage5_icon() {
      return this.getImageUrl('advantage5_icon', '/assets/kh3.png');
    },
    advantage5_text() {
      return this.getContent('account_delegate_advantage5_text', '个性化的投资方案定制，根据您的财务目标、风险承受能力和投资期限，量身定制投资策略。');
    },
    advantage6_icon() {
      return this.getImageUrl('advantage6_icon', '/assets/kh6.png');
    },
    advantage6_text() {
      return this.getContent('account_delegate_advantage6_text', '严格的风控体系，多重安全保障，确保您的账户资金和投资安全，万无一失。');
    },

    // 特权板块
    privilege_image() {
      return this.getImageUrl('privilege_image', '/assets/image3.png');
    },
    privilege_title() {
      return this.getContent('account_delegate_privilege_title', '账户委托专属特权');
    },
    privilege_items() {
      const itemsJson = this.getContent('account_delegate_privilege_items', '["专属投资顾问一对一服务","优先获取优质投资机会","定期投资报告和策略调整","VIP客户专属活动邀请"]');
      try {
        return JSON.parse(itemsJson);
      } catch (e) {
        return [
          '专属投资顾问一对一服务',
          '优先获取优质投资机会',
          '定期投资报告和策略调整',
          'VIP客户专属活动邀请'
        ];
      }
    },
    privilege_highlight() {
      return this.getContent('account_delegate_privilege_highlight', '专业资产管理');
    },
    privilege_button_text() {
      return this.getContent('account_delegate_privilege_button_text', '了解详情');
    },

    // 工具板块
    tools_title() {
      return this.getContent('account_delegate_tools_title', '专业的账户委托工具');
    },
    tools_image() {
      return this.getImageUrl('tools_image', '/assets/image3.png');
    },
    tools_items() {
      const itemsJson = this.getContent('account_delegate_tools_items', '[{"title":"智能资产配置","description":"基于大数据和AI算法，智能调整您的投资组合"},{"title":"风险评估系统","description":"实时评估投资组合风险，提供风险预警和调整建议"},{"title":"投资报告分析","description":"定期生成详细的投资报告，帮助您了解投资收益情况"}]');
      try {
        return JSON.parse(itemsJson);
      } catch (e) {
        return [
          {
            title: '智能资产配置',
            description: '基于大数据和AI算法，智能调整您的投资组合'
          },
          {
            title: '风险评估系统',
            description: '实时评估投资组合风险，提供风险预警和调整建议'
          },
          {
            title: '投资报告分析',
            description: '定期生成详细的投资报告，帮助您了解投资收益情况'
          }
        ];
      }
    },
    tools_button_text() {
      return this.getContent('account_delegate_tools_button_text', '了解详情');
    },

    // 交易能力
    trading_title() {
      return this.getContent('account_delegate_trading_title', '强大的账户委托服务');
    },
    trading_capabilities() {
      const capabilitiesJson = this.getContent('account_delegate_trading_capabilities', '[{"icon":"/assets/khb1.png","title":"全终端覆盖","features":["支持桌面端和移动端","随时随地查看账户情况"]},{"icon":"/assets/khb2.png","title":"多元化投资","features":["股票、基金、债券等多种资产","满足不同投资需求"]},{"icon":"/assets/khb3.png","title":"实时监控","features":["24小时市场监控","及时把握投资机会"]},{"icon":"/assets/khb4.png","title":"专业研究支持","features":["专业的投资研究团队","提供深度市场分析"]},{"icon":"/assets/khb5.png","title":"风控保障","features":["严格的风险控制体系","保障账户资金安全"]}]');
      try {
        return JSON.parse(capabilitiesJson);
      } catch (e) {
        return [
          {
            icon: '/assets/khb1.png',
            title: '全终端覆盖',
            features: ['支持桌面端和移动端', '随时随地查看账户情况']
          },
          {
            icon: '/assets/khb2.png',
            title: '多元化投资',
            features: ['股票、基金、债券等多种资产', '满足不同投资需求']
          },
          {
            icon: '/assets/khb3.png',
            title: '实时监控',
            features: ['24小时市场监控', '及时把握投资机会']
          },
          {
            icon: '/assets/khb4.png',
            title: '专业研究支持',
            features: ['专业的投资研究团队', '提供深度市场分析']
          },
          {
            icon: '/assets/khb5.png',
            title: '风控保障',
            features: ['严格的风险控制体系', '保障账户资金安全']
          }
        ];
      }
    },

    // 值得信赖
    trusted_title() {
      return this.getContent('account_delegate_trusted_title', '值得信赖的账户委托服务');
    },
    trusted_subtitle() {
      return this.getContent('account_delegate_trusted_subtitle', '我们以专业、安全、合规的服务，为您的资产保值增值保驾护航');
    },
    trusted_services() {
      const servicesJson = this.getContent('account_delegate_trusted_services', '[{"icon":"/assets/zh11.png","title":"资产安全保障","items":["客户资产独立托管","严格的风控审核","多重安全防护体系"]},{"icon":"/assets/zh22.png","title":"数据安全与隐私","items":["ISO27001信息安全认证","加密传输和存储","严格的隐私保护政策"]},{"icon":"/assets/zh33.png","title":"专业服务团队","items":["CFA持证投资顾问","7x24小时客户服务","个性化投资方案定制"]}]');
      try {
        return JSON.parse(servicesJson);
      } catch (e) {
        return [
          {
            icon: '/assets/zh11.png',
            title: '资产安全保障',
            items: [
              '客户资产独立托管',
              '严格的风控审核',
              '多重安全防护体系'
            ]
          },
          {
            icon: '/assets/zh22.png',
            title: '数据安全与隐私',
            items: [
              'ISO27001信息安全认证',
              '加密传输和存储',
              '严格的隐私保护政策'
            ]
          },
          {
            icon: '/assets/zh33.png',
            title: '专业服务团队',
            items: [
              'CFA持证投资顾问',
              '7x24小时客户服务',
              '个性化投资方案定制'
            ]
          }
        ];
      }
    },

    // 荣誉奖项
    awards_title() {
      return this.getContent('account_delegate_awards_title', '荣誉奖项展示');
    },
    awards() {
      const awardsJson = this.getContent('account_delegate_awards', '[{"image":"image_account_delegate_award_1","lines":["最佳资产管理奖 2023","亚洲金融科技创新奖","香港金融科技卓越奖"]},{"image":"image_account_delegate_award_2","lines":["最佳客户服务奖 2023","国际投资论坛金奖","亚洲财富管理评选"]},{"image":"image_account_delegate_award_3","lines":["最佳投资顾问服务奖","金融科技创新领先奖"]},{"image":"image_account_delegate_award_4","lines":["最佳财富管理平台奖","亚洲最佳资产管理评选"]}]');
      try {
        return JSON.parse(awardsJson);
      } catch (e) {
        console.error('解析账户委托页面荣誉奖项数据失败:', e);
        return [
          {
            image: "image_account_delegate_award_1",
            lines: [
              '最佳资产管理奖 2023',
              '亚洲金融科技创新奖',
              '香港金融科技卓越奖'
            ]
          },
          {
            image: "image_account_delegate_award_2",
            lines: [
              '最佳客户服务奖 2023',
              '国际投资论坛金奖',
              '亚洲财富管理评选'
            ]
          },
          {
            image: "image_account_delegate_award_3",
            lines: [
              '最佳投资顾问服务奖',
              '金融科技创新领先奖'
            ]
          },
          {
            image: "image_account_delegate_award_4",
            lines: [
              '最佳财富管理平台奖',
              '亚洲最佳资产管理评选'
            ]
          }
        ];
      }
    },

    // 账户类型
    accounts_title() {
      return this.getContent('account_delegate_accounts_title', '支持账户类型');
    },
    accounts_subtitle() {
      return this.getContent('account_delegate_accounts_subtitle', '个人和机构投资者均可享受专业的账户委托服务');
    },
    account_types() {
      const typesJson = this.getContent('account_delegate_account_types', '[{"icon":"/assets/khd1.png","name":"个人账户"},{"icon":"/assets/khd2.png","name":"机构账户"}]');
      try {
        return JSON.parse(typesJson);
      } catch (e) {
        return [
          {
            icon: '/assets/khd1.png',
            name: '个人账户'
          },
          {
            icon: '/assets/khd2.png',
            name: '机构账户'
          }
        ];
      }
    },
    account_description() {
      const descJson = this.getContent('account_delegate_account_description', '{"title":"机构账户说明","content":"机构账户专为专业投资机构和高净值个人设计，提供更丰富的投资工具和更个性化的服务。如需开设机构账户，请联系我们的投资顾问。"}');
      try {
        return JSON.parse(descJson);
      } catch (e) {
        return {
          title: '机构账户说明',
          content: '机构账户专为专业投资机构和高净值个人设计，提供更丰富的投资工具和更个性化的服务。如需开设机构账户，请联系我们的投资顾问。'
        };
      }
    },

    // 订单类型详细内容
    orderTypes_content() {
      const contentJson = this.getContent('account_delegate_order_types_content', '{}');
      try {
        return JSON.parse(contentJson);
      } catch (e) {
        return {};
      }
    },

    // 到价买入详细内容
    buyIfTouched_triggerContents() {
      const contentJson = this.getContent('account_delegate_buy_if_touched_content', '{}');
      try {
        return JSON.parse(contentJson);
      } catch (e) {
        return {};
      }
    },

    buyIfTouched_currentTriggerContent() {
      return this.buyIfTouched_triggerContents[this.buyIfTouched_activeTrigger] || this.buyIfTouched_triggerContents.buyIfTouched;
    },

    orderTypesTabs() {
      const tabsJson = this.getContent('order_types_tabs', '[{"key":"atAuctionLimit","name":"竞价限价单"},{"key":"atAuctionMarket","name":"竞价市价单"},{"key":"enhancedLimit","name":"增强限价单"},{"key":"market","name":"市价单"}]');
      try {
        return JSON.parse(tabsJson);
      } catch (e) {
        return [
          { key: 'atAuctionLimit', name: '竞价限价单' },
          { key: 'atAuctionMarket', name: '竞价市价单' },
          { key: 'enhancedLimit', name: '增强限价单' },
          { key: 'market', name: '市价单' }
        ];
      }
    },

    buyIfTouchedTriggerTabs() {
      const tabsJson = this.getContent('buy_if_touched_trigger_tabs', '[{"key":"buyIfTouched","name":"到价买入"},{"key":"sellIfTouched","name":"到价卖出"},{"key":"bounceBuy","name":"反弹买入"},{"key":"fallSell","name":"回落卖出"}]');
      try {
        return JSON.parse(tabsJson);
      } catch (e) {
        return [
          { key: 'buyIfTouched', name: '到价买入' },
          { key: 'sellIfTouched', name: '到价卖出' },
          { key: 'bounceBuy', name: '反弹买入' },
          { key: 'fallSell', name: '回落卖出' }
        ];
      }
    },

    // 全球交易表格数据
    globalTradingTableData() {
      const tableJson = this.getContent('account_delegate_global_trading_table', '[{"country":"中国香港","flag":"🇭🇰","stocks":true,"etfs":true,"bonds":true,"warrants":true,"options":true},{"country":"美国","flag":"🇺🇸","stocks":true,"etfs":true,"bonds":true,"warrants":true,"options":true}]');
      try {
        return JSON.parse(tableJson);
      } catch (e) {
        return [
          {"country":"中国香港","flag":"🇭🇰","stocks":true,"etfs":true,"bonds":true,"warrants":true,"options":true},
          {"country":"美国","flag":"🇺🇸","stocks":true,"etfs":true,"bonds":true,"warrants":true,"options":true}
        ];
      }
    }
  },
  async mounted() {
    // 加载账户委托页面内容
    this.loadContent();

    // 监听语言切换事件
    window.addEventListener('localeChange', this.handleLocaleChange);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('localeChange', this.handleLocaleChange);
  },
  methods: {
    handleLocaleChange(e) {
      if (e.detail && e.detail.locale) {
        this.currentLang = e.detail.locale;
        this.loadContent();
      }
    },

    async loadContent() {
      try {
        // 获取账户委托页面所有内容
        const pageContent = await getContentsByCategory('account_delegate_page', this.currentLang || 'cn');
        this.contentData = pageContent;

        // 提取图片URL到 imageUrls
        Object.keys(pageContent).forEach(key => {
          if (pageContent[key] && (key.startsWith('image_') || pageContent[key].startsWith('/uploads/') || pageContent[key].startsWith('http'))) {
            this.$set(this.imageUrls, key, pageContent[key]);
          }
        });

      } catch (error) {
        console.error('加载账户委托页面内容失败:', error);
        // 使用默认数据
      }
    },

    // 订单类型相关方法
    setOrderTab(tabKey) {
      this.orderTypes_orderTab = tabKey;
    },

    getOrderTypeDisplayName(tabKey) {
      const tab = this.orderTypes_tabs.find(t => t.key === tabKey);
      return tab ? tab.name : tabKey;
    },

    // 到价买入相关方法
    setActiveTrigger(triggerKey) {
      this.buyIfTouched_activeTrigger = triggerKey;
    }
  },
  metaInfo: {
    title: '账户委托 - 红土证券'
  }
}
</script>

<style scoped>
/* 复用 AccountDelegate.vue 的样式 */
.hero-banner {
  position: relative;
  height: 40vh;
  min-height: 600px;
  overflow: hidden;
  background:url("https://img.shetu66.com/2023/07/04/1688453333865029.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 天空渐变背景 */
.sky-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    #1e3a8a 0%,
    #3b82f6 30%,
    #60a5fa 60%,
    #93c5fd 100%
  );
}

/* 云朵样式 */
.cloud {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50px;
  animation: float-cloud 20s ease-in-out infinite;
}

.cloud-1 {
  width: 120px;
  height: 40px;
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.cloud-2 {
  width: 80px;
  height: 30px;
  top: 25%;
  right: 15%;
  animation-delay: 5s;
}

.cloud-3 {
  width: 100px;
  height: 35px;
  top: 35%;
  left: 20%;
  animation-delay: 10s;
}

@keyframes float-cloud {
  0%, 100% {
    transform: translateX(0px) translateY(0px);
  }
  25% {
    transform: translateX(10px) translateY(-5px);
  }
  50% {
    transform: translateX(-5px) translateY(-10px);
  }
  75% {
    transform: translateX(-10px) translateY(-5px);
  }
}

/* 岩石样式 */
.rock {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 60%;
  height: 80%;
  background: linear-gradient(135deg, #8B4513 0%, #654321 50%, #A0522D 100%);
  clip-path: polygon(
    20% 100%,
    30% 90%,
    45% 95%,
    60% 85%,
    75% 90%,
    85% 80%,
    95% 85%,
    100% 75%,
    90% 65%,
    95% 50%,
    85% 40%,
    90% 25%,
    80% 15%,
    70% 10%,
    60% 5%,
    50% 0%,
    40% 5%,
    30% 0%,
    20% 10%,
    15% 20%,
    10% 30%,
    5% 40%,
    0% 50%,
    5% 60%,
    0% 70%,
    10% 80%,
    15% 90%,
    20% 100%
  );
  box-shadow: inset -20px -20px 40px rgba(0, 0, 0, 0.3);
}

/* 添加岩石纹理效果 */
.rock::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 30%, rgba(139, 69, 19, 0.3) 1px, transparent 1px),
    radial-gradient(circle at 70% 20%, rgba(160, 82, 45, 0.2) 1px, transparent 1px),
    radial-gradient(circle at 50% 60%, rgba(101, 67, 33, 0.4) 2px, transparent 2px);
  background-size: 20px 20px, 15px 15px, 25px 25px;
}

/* 树木样式 */
.trees {
  position: absolute;
}

.left-trees {
  left: 5%;
  top: 20%;
  height: 60%;
}

.top-trees {
  top: 5%;
  left: 30%;
  right: 30%;
  height: 20%;
  display: flex;
  justify-content: space-around;
}

.tree {
  position: relative;
  background: linear-gradient(135deg, #0f5132 0%, #1e3a8a 100%);
  border-radius: 50% 50% 0 0;
  box-shadow: inset 0 -10px 20px rgba(0, 0, 0, 0.3);
}

.left-trees .tree {
  width: 40px;
  height: 120px;
  margin-bottom: 20px;
}

.tree-1 {
  transform: rotate(-5deg);
  margin-left: 10px;
}

.tree-2 {
  transform: rotate(3deg);
  margin-left: -5px;
}

.tree-3 {
  transform: rotate(-2deg);
  margin-left: 15px;
}

.top-trees .tree {
  width: 25px;
  height: 60px;
}

.tree-4 {
  transform: rotate(-8deg);
}

.tree-5 {
  transform: rotate(6deg);
}

/* 内容区域 */
.banner-content {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
  z-index: 10;
}

.text-content {
  text-align: left;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 300;
  color: white;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1em;
}

.main-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 2rem;
  letter-spacing: 0.05em;
  line-height: 1.1;
}

.cta-button {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.05em;
}

.cta-button:hover {
  background: white;
  color: #1e3a8a;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

/* 委托客户内容样式 */
.delegate-content {
  min-height: 400px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .hero-banner {
    height: 80vh;
    min-height: 500px;
  }

  .rock {
    width: 70%;
    height: 70%;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .banner-content {
    left: 10%;
  }
}

@media (max-width: 768px) {
  .hero-banner {
    height: 70vh;
    min-height: 400px;
  }

  .rock {
    width: 80%;
    height: 60%;
  }

  .left-trees {
    left: 2%;
    top: 25%;
  }

  .main-title {
    font-size: 2rem;
  }

  .brand-name {
    font-size: 1.2rem;
  }

  .banner-content {
    left: 8%;
  }

  .cta-button {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 640px) {
  .hero-banner {
    height: 60vh;
    min-height: 350px;
  }

  .rock {
    width: 90%;
    height: 50%;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .brand-name {
    font-size: 1rem;
  }

  .banner-content {
    left: 5%;
  }

  .left-trees {
    display: none; /* 在小屏幕上隐藏左侧树木以节省空间 */
  }
}

/* 专享特权板块样式 */
.privilege-cards {
  position: relative;
}

.privilege-card {
  min-height: 400px;
}

.icon-wrapper {
  width: 3rem;
  height: 3rem;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tag {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.privilege-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
}

.privilege-item:last-child {
  border-bottom: none;
}

.highlight-box {
  border-radius: 0.375rem;
}

/* 移动端响应式调整 */
@media (max-width: 768px) {
  .advantage-card {
    padding: 1rem;
  }

  .advantage-card .flex {
    flex-direction: column;
    align-items: center;
  }

  .advantage-card .space-x-4 > * + * {
    margin-left: 0;
    margin-top: 1rem;
  }

  .advantage-card p {
    font-size: 0.875rem;
    line-height: 1.5;
    text-align: center;
  }

  .icon-container {
    width: 2.5rem;
    height: 2.5rem;
  }

  .privilege-card {
    min-height: auto;
    padding: 1.5rem;
  }

  .text-content h3 {
    font-size: 1.875rem;
    margin-bottom: 1rem;
  }

  .privilege-item {
    padding: 0.5rem 0;
  }

  .icon-wrapper {
    width: 2.5rem;
    height: 2.5rem;
  }
}

/* 投资者工具板块样式 */
.phone-showcase {
  perspective: 1000px;
}

.phone-mockup {
  transform: rotateY(-5deg);
}

.phone-frame {
  width: 280px;
  max-width: 90vw;
}

.phone-screen {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.tab {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
}

.tab.active {
  background-color: #3b82f6;
  color: white;
}

.rating-section {
  border: 1px solid #dbeafe;
}

.chart-placeholder {
  position: relative;
}

.related-companies {
  border-top: 1px solid #e5e7eb;
  padding-top: 0.5rem;
}

/* 交易能力板块样式 */
.capability-card {
  border: 1px solid #e5e7eb;
}

.capability-card .icon-container {
  width: 3rem;
  height: 3rem;
  background: #f9fafb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

/* 技术领先板块样式 */
.nav-tab {
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  position: relative;
}

.nav-tab.active {
  color: #1f2937;
  border-bottom-color: #1f2937;
}

.nav-tab:hover {
  color: #374151;
}

.content-box {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #ececec;
  box-shadow: 0 6px 18px rgba(16,24,40,0.03);
  padding: 2.5rem;
  text-align: left;
}

.advantages-grid {
  max-width: 1200px;
  margin: 0 auto;
}

.advantage-item .icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.advantage-item .icon-wrapper::before {
  /* dashed square border */
  content: '';
  position: absolute;
  width: 56px;
  height: 56px;
  border: 1px dashed rgba(249,115,22,0.35);
  border-radius: 8px;
  left: -4px;
  top: -4px;
}

.advantage-item .icon-inner {
  width: 36px;
  height: 36px;
  background: #fff7ed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f97316;
  z-index: 2;
}

/* 移动端响应式调整 */
@media (max-width: 1024px) {
  .phone-mockup {
    transform: rotateY(0deg);
  }

  .phone-frame {
    width: 240px;
  }
}

@media (max-width: 768px) {
  .investor-tools .grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .text-content {
    order: 2;
  }

  .phone-showcase {
    order: 1;
  }

  .phone-frame {
    width: 200px;
  }

  .phone-screen {
    height: 320px;
  }

  .text-content h3 {
    font-size: 1.875rem;
    text-align: center;
  }

  .text-content ul {
    text-align: left;
  }
}

@media (max-width: 640px) {
  .phone-frame {
    width: 180px;
    height: 280px;
    padding: 0.75rem;
  }

  .app-header .flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .tab {
    font-size: 0.625rem;
    padding: 0.125rem 0.25rem;
  }
}

/* 支持账户类型样式 */
.account-types .account-icon {
  box-shadow: 0 8px 20px rgba(16,24,40,0.06);
}
.account-icon svg { fill: white; }
.service-card .icon-circle img { width: 100%; height: 100%; object-fit: cover;}

/* 全球交易板块样式 */
.global-trading {
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

/* 特色亮点展示区样式 */
.features-grid {
  max-width: 1000px;
  margin: 0 auto;
}

.feature-item {
  padding: 0 1rem;
}

.feature-icon {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon:hover {
  background-color: rgba(255, 153, 0, 0.05);
  transform: translateY(-2px);
}

.feature-icon svg {
  width: 48px;
  height: 48px;
}

/* 表格样式 */
.global-trading table {
  border-collapse: collapse;
  width: 100%;
  margin: 0 auto;
  max-width: 1000px;
}

.global-trading th,
.global-trading td {
  padding: 1rem 1.5rem;
  text-align: left;
  border: 1px solid #e5e7eb;
}

.global-trading th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.global-trading tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.global-trading tbody tr:hover {
  background-color: #f3f4f6;
}

.global-trading .country-cell {
  display: flex;
  align-items: center;
  font-weight: 500;
}

/* 橙色圆点样式 */
.dot-indicator {
  width: 12px;
  height: 12px;
  background-color: #ff9900;
  border-radius: 50%;
  margin: 0 auto;
}

/* 底部链接样式 */
.market-link {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  text-decoration: none;
  font-size: 0.95rem;
}

.market-link:hover {
  background-color: rgba(255, 153, 0, 0.1);
  transform: translateY(-1px);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }

  .feature-item {
    padding: 0 0.5rem;
  }

  .feature-icon {
    width: 70px;
    height: 70px;
  }

  .feature-icon svg {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 768px) {
  .global-trading .text-4xl {
    font-size: 2rem;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .feature-item {
    margin-bottom: 1rem;
  }

  .feature-icon {
    width: 60px;
    height: 60px;
  }

  .feature-icon svg {
    width: 35px;
    height: 35px;
  }

  .global-trading th,
  .global-trading td {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }

  .country-cell span:not(.text-lg) {
    font-size: 0.85rem;
  }

  .market-link {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 640px) {
  .features-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .global-trading .text-center.mb-12 {
    margin-bottom: 2rem;
  }

  .global-trading .text-4xl {
    font-size: 1.75rem;
  }

  .feature-item {
    text-align: center;
  }

  .feature-icon {
    width: 50px;
    height: 50px;
    margin: 0 auto 0.75rem;
  }

  .feature-icon svg {
    width: 30px;
    height: 30px;
  }

  .overflow-x-auto {
    font-size: 0.75rem;
  }

  .global-trading th,
  .global-trading td {
    padding: 0.5rem 0.25rem;
  }

  .flex.justify-center.gap-8 {
    flex-direction: column;
    gap: 1rem;
  }

  .market-link {
    justify-content: center;
    padding: 0.75rem 1.5rem;
  }
}

/* 订单类型板块样式 */
.nav-tab {
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  position: relative;
  cursor: pointer;
  background: none;
  border: none;
}

.nav-tab.active {
  color: #1f2937;
  border-bottom-color: #1f2937;
}

.nav-tab:hover {
  color: #374151;
}

.order-type-content h3 {
  margin-bottom: 1rem;
}

.order-type-content p {
  line-height: 1.6;
  margin-bottom: 1rem;
}

.order-type-content ul {
  margin-top: 0.5rem;
}

.order-type-content li {
  position: relative;
  padding-left: 1rem;
}

.order-type-content li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #6b7280;
}

/* 到价买入板块样式 */
.top-nav-tab {
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.top-nav-tab.active {
  color: white;
  border-bottom-color: white;
}

.top-nav-tab:hover {
  color: white;
  opacity: 0.9;
}

/* 响应式设计 - 订单类型 */
@media (max-width: 1024px) {
  .nav-tab {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .flex.justify-start.gap-8 {
    gap: 1rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .nav-tab {
    white-space: nowrap;
    min-width: fit-content;
  }

  .text-2xl {
    font-size: 1.5rem;
  }

  .text-3xl {
    font-size: 1.75rem;
  }
}

@media (max-width: 640px) {
  .py-16 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .gap-8 {
    gap: 1rem;
  }
}

/* 响应式设计 - 到价买入 */
@media (max-width: 768px) {
  .if-touched-section {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .flex.justify-start.gap-8 {
    gap: 1rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .top-nav-tab {
    white-space: nowrap;
    min-width: fit-content;
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .text-2xl {
    font-size: 1.25rem;
  }
}

@media (max-width: 640px) {
  .grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .top-nav-tab {
    padding: 0.375rem 0.625rem;
    font-size: 0.8rem;
  }
}

/* 保证金交易板块样式 */
.margin-trading {
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

/* 分割线样式 */
.divider {
  margin: 2rem 0;
}

/* 示例卡片样式 */
.example-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.example-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

/* 柱状图容器样式 */
.chart-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 200px;
  margin-bottom: 1rem;
}

.bar-chart {
  display: flex;
  flex-direction: column;
  width: 80px;
  height: 180px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

/* 柱状图段样式 */
.bar-segment {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
}

.bar-segment.financing-bar {
  background: linear-gradient(135deg, #ff9900 0%, #ffad33 100%);
  color: white;
  font-size: 0.7rem;
  font-weight: 500;
  text-align: center;
  padding: 0.25rem;
}

.bar-segment.cash-bar {
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  color: white;
  font-size: 0.7rem;
  font-weight: 500;
  text-align: center;
  padding: 0.25rem;
}

.bar-label {
  transform: rotate(-90deg);
  white-space: nowrap;
  font-size: 0.65rem;
  line-height: 1;
  transform-origin: center;
}

/* 优势网格样式 */
.advantages-grid {
  max-width: 1000px;
  margin: 0 auto;
}

.advantage-item {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.advantage-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.advantage-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.advantage-icon svg {
  width: 100%;
  height: 100%;
}

/* 风险提示区样式 */
.risk-warning {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

/* 响应式设计 - 保证金交易 */
@media (max-width: 1024px) {
  .concept-examples {
    gap: 2rem;
  }

  .chart-container {
    height: 180px;
  }

  .bar-chart {
    width: 70px;
    height: 160px;
  }

  .bar-label {
    font-size: 0.6rem;
  }
}

@media (max-width: 768px) {
  .margin-trading .text-4xl {
    font-size: 2rem;
  }

  .margin-trading .text-lg {
    font-size: 1rem;
  }

  .concept-examples {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .advantages-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .advantage-item {
    flex-direction: column;
    text-align: center;
  }

  .advantage-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .chart-container {
    height: 160px;
  }

  .bar-chart {
    width: 60px;
    height: 140px;
  }

  .bar-label {
    font-size: 0.55rem;
  }
}

@media (max-width: 640px) {
  .margin-trading .text-4xl {
    font-size: 1.75rem;
  }

  .margin-trading .text-2xl {
    font-size: 1.5rem;
  }

  .concept-examples {
    gap: 1.5rem;
  }

  .example-card {
    padding: 1.5rem;
  }

  .chart-container {
    height: 140px;
  }

  .bar-chart {
    width: 50px;
    height: 120px;
  }

  .bar-label {
    font-size: 0.5rem;
  }

  .advantages-grid {
    gap: 1rem;
  }

  .risk-warning {
    padding: 1.5rem;
  }

  .risk-warning ul {
    padding-left: 0;
  }
}

/* 做空交易板块样式 */
.short-selling {
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

/* 流程图容器样式 */
.process-flow {
  position: relative;
}

.flow-diagram {
  position: relative;
  padding: 2rem 0;
}

.flow-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}

.flow-row.bottom-row {
  margin-bottom: 0;
  margin-top: -1rem;
}

/* 流程步骤样式 */
.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  position: relative;
}

.step-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.step-circle:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.broker-circle {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  border: 3px solid #ec4899;
}

.trader-circle {
  width: 140px;
  height: 140px;
  background: linear-gradient(135deg, #ff9900 0%, #ffad33 100%);
  border: 3px solid #e67e22;
  position: relative;
}

.market-circle {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  border: 3px solid #ec4899;
}

.circle-content {
  text-align: center;
  position: relative;
}

.step-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-top: 0.5rem;
  display: block;
}

.trader-label {
  color: white;
  margin-top: 0.25rem;
}

/* 箭头线样式 */
.flow-arrow {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  min-width: 80px;
  margin: 0 1rem;
}

.arrow-right .arrow-line {
  width: 60px;
  height: 3px;
  position: relative;
  margin-bottom: 0.5rem;
}

.arrow-left .arrow-line {
  width: 60px;
  height: 3px;
  position: relative;
  margin-bottom: 0.5rem;
}

.dashed-line {
  border-top: 2px dashed #9ca3af;
}

.solid-line {
  background-color: #ff9900;
}

.green-line {
  background-color: #10b981;
}

.orange-line {
  background-color: #ff9900;
}

.arrow-head {
  width: 0;
  height: 0;
  border-left: 8px solid #ff9900;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

.arrow-head-left {
  width: 0;
  height: 0;
  border-right: 8px solid #ff9900;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
}

.green-head {
  border-left-color: #10b981;
}

.orange-head {
  border-left-color: #ff9900;
}

.arrow-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  text-align: center;
  white-space: nowrap;
  max-width: 80px;
}

/* 连接线样式 */
.flow-connection {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.vertical-line {
  position: absolute;
  width: 2px;
  background: linear-gradient(to bottom, #9ca3af 0%, #9ca3af 50%, transparent 50%, transparent 100%);
  background-size: 2px 8px;
}

.left-line {
  left: 25%;
  top: 120px;
  height: 80px;
}

.right-line {
  right: 25%;
  top: 120px;
  height: 80px;
}

/* 优势网格样式 */
.short-advantages .advantages-grid {
  max-width: 1000px;
  margin: 0 auto;
}

.short-advantages .advantage-item {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.short-advantages .advantage-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.short-advantages .advantage-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.short-advantages .advantage-icon svg {
  width: 100%;
  height: 100%;
}

/* 响应式设计 - 做空交易 */
@media (max-width: 1024px) {
  .flow-row {
    flex-wrap: wrap;
    gap: 1rem;
  }

  .flow-arrow {
    margin: 0.5rem;
  }

  .arrow-line {
    width: 40px;
  }

  .step-circle {
    width: 100px;
    height: 100px;
  }

  .trader-circle {
    width: 120px;
    height: 120px;
  }

  .step-label {
    font-size: 0.8rem;
  }

  .vertical-line {
    display: none;
  }

  .bottom-row .flow-arrow {
    order: -1;
  }
}

@media (max-width: 768px) {
  .short-selling .text-4xl {
    font-size: 2rem;
  }

  .short-selling .text-lg {
    font-size: 1rem;
  }

  .flow-row {
    flex-direction: column;
    gap: 1.5rem;
  }

  .flow-row.bottom-row {
    flex-direction: row-reverse;
    margin-top: 0;
  }

  .flow-arrow {
    flex-direction: row;
    align-items: center;
    margin: 0.5rem 0;
  }

  .flow-arrow .arrow-line {
    width: 40px;
    height: 3px;
    margin: 0 0.5rem 0 0;
  }

  .flow-arrow .arrow-label {
    margin: 0;
  }

  .step-circle {
    width: 90px;
    height: 90px;
  }

  .trader-circle {
    width: 110px;
    height: 110px;
  }

  .advantages-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .advantage-item {
    flex-direction: column;
    text-align: center;
  }

  .advantage-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .arrow-label {
    font-size: 0.7rem;
  }
}

@media (max-width: 640px) {
  .short-selling .text-4xl {
    font-size: 1.75rem;
  }

  .short-selling .text-2xl {
    font-size: 1.5rem;
  }

  .flow-row.bottom-row {
    flex-direction: column;
    gap: 1rem;
  }

  .flow-row.bottom-row .flow-arrow {
    flex-direction: column;
    align-items: center;
  }

  .flow-row.bottom-row .flow-arrow .arrow-line {
    width: 30px;
    height: 3px;
    margin: 0 0 0.5rem 0;
  }

  .step-circle {
    width: 80px;
    height: 80px;
  }

  .trader-circle {
    width: 100px;
    height: 100px;
  }

  .flow-arrow {
    margin: 0.5rem 0;
    min-width: 60px;
  }

  .arrow-line {
    width: 30px;
  }

  .step-label {
    font-size: 0.75rem;
  }
}
</style>